module.exports = __webpack_public_path__ + "static/media/53-iveco.352a8d79.jpg";